import * as urlConstants from "../Constants/urlConstants";
import * as apiProvider from "./provider";

export function login(reqData) {
  return apiProvider.post(urlConstants.LOGIN, reqData);
}

export function logout(reqData) {
  return apiProvider.post(urlConstants.LOGOUT, reqData);
}

export function resetPassword(reqData) {
  return apiProvider.post(urlConstants.RESET_PASSWORD, reqData);
}

export function changePassword(reqData) {
  return apiProvider.post(urlConstants.CHANGE_PASSWORD, reqData);
}

export function forgotPassword(reqData) {
  return apiProvider.post(urlConstants.FORGOT_PASSWORD, reqData);
}

export function masterData() {
  return apiProvider.getAll(urlConstants.MASTER_DATA);
}

export function systemData() {
  return apiProvider.getAll(urlConstants.SYSTEM_DATA);
}

export function getProfile() {
  return apiProvider.getAll(urlConstants.GET_PROFILE);
}

export function getMedicineList(query) {
  return apiProvider.post(urlConstants.GET_MEDICINE_LIST, query);
}

export function getMedicineBillList(query) {
  return apiProvider.post(urlConstants.GET_MEDICINE_BILL_LIST, query);
}
export function getCreditNoteList(query) {
  return apiProvider.post(urlConstants.CREDIT_NOTES_LIST, query);
}
export function editCreditNote(data) {
  return apiProvider.post(urlConstants.CREDIT_NOTES_EDIT, data);
}
export function getMedicineTypeList(query) {
  return apiProvider.getAll(urlConstants.GET_MEDICINE_TYPE_LIST + query);
}

export function getServiceTypeList(query) {
  return apiProvider.getAll(urlConstants.GET_SERVICE_TYPE_LIST + query);
}

export function getDepartmentList(query) {
  return apiProvider.getAll(urlConstants.GET_DEPARTMENT_LIST + query);
}

export function getSupplierList(query) {
  return apiProvider.getAll(urlConstants.GET_SUPPLIER_LIST + query);
}

export function getServiceList(query) {
  return apiProvider.getAll(urlConstants.GET_SERVICE_LIST + query);
}

// Function removed

export function addMedicine(reqData) {
  return apiProvider.post(urlConstants.ADD_MEDICINE, reqData);
}

export function addMedicineType(reqData) {
  return apiProvider.post(urlConstants.ADD_MEDICINE_TYPE, reqData);
}

export function addServiceType(reqData) {
  return apiProvider.post(urlConstants.ADD_SERVICE_TYPE, reqData);
}

// Function removed

export function addDepartment(reqData) {
  return apiProvider.post(urlConstants.ADD_DEPARTMENT, reqData);
}

export function addSupplier(reqData) {
  return apiProvider.post(urlConstants.ADD_SUPPLIER, reqData);
}

export function addService(reqData) {
  return apiProvider.post(urlConstants.ADD_SERVICE, reqData);
}

export function getReports(query) {
  return apiProvider.getAll(urlConstants.GET_REPORTS + query);
}

export function editMedicine(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_MEDICINE + id, reqData);
}

// Function removed

export function editDepartment(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_DEPARTMENT + id, reqData);
}

export function editSupplier(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_SUPPLIER + id, reqData);
}

export function editService(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_SERVICE + id, reqData);
}

export function editServiceType(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_SERVICE_TYPE + id, reqData);
}

export function editMedicineType(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_MEDICINE_TYPE + id, reqData);
}

export function changeSupplierStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_SUPPLIER_STATUS + id, reqData);
}

// Function removed

export function changeDepartmentStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_DEPARTMENT_STATUS + id, reqData);
}

export function changeServiceStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_SERVICE_STATUS + id, reqData);
}

export function changeServiceTypeStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_SERVICE_TYPE_STATUS + id, reqData);
}

export function changeMedicineStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_MEDICINE_STATUS + id, reqData);
}

export function changeMedicineTypeStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_MEDICINE_TYPE_STATUS + id, reqData);
}

export function deleteMedicine(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_MEDICINE + id);
}

export function getPurchaseMedicineList(query) {
  return apiProvider.getAll(urlConstants.GET_PURCHASE_MEDICINE_LIST + query);
}

export function importMaster(query, reqData) {
  return apiProvider.post(urlConstants.IMPORT_MASTER + query, reqData);
}

export function exportMaster(query, reqData) {
  return apiProvider.post(urlConstants.EXPORT_MASTER + query, reqData);
}

export function addPurchaseMedicine(id, reqData) {
  return apiProvider.post(urlConstants.ADD_PURCHASE_MEDICINE + id, reqData);
}

export function editPurchaseMedicine(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_PURCHASE_MEDICINE + id, reqData);
}

export function addProductReturn(reqData) {
  return apiProvider.post(urlConstants.MEDICINE_RETURN, reqData);
}

export function deletePurchaseMedicine(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_PURCHASE_MEDICINE + id);
}

export function searchPatient(query) {
  return apiProvider.getAll(urlConstants.SEARCH_PATIENT + query);
}

export function addPatientVisit(reqData) {
  return apiProvider.post(urlConstants.ADD_PATIENT_VISIT, reqData);
}

export function getPatientsList(reqData) {
  return apiProvider.post(urlConstants.GET_PATIENTS_LIST, reqData);
}
export function getPatientsVisitList(reqData) {
  return apiProvider.post(urlConstants.GET_PATIENTS_NEXT_LIST, reqData);
}

export function getPatientsTrackReport(reqData) {
  return apiProvider.post(urlConstants.GET_PATIENTS_TRACK_REPORT, reqData);
}

export function getPatientDetailsWithVisits(id) {
  return apiProvider.getAll(urlConstants.GET_PATIENT_DETAILS_WITH_VISITS + id);
}

export function updatePatientData(id, reqData) {
  return apiProvider.post(urlConstants.UPDATE_PATIENT_DETAILS + id, reqData);
}

export function addPrescription(id, reqData) {
  return apiProvider.post(urlConstants.ADD_PRESCRIPTION + id, reqData);
}

export function getPrescription(id) {
  return apiProvider.getAll(urlConstants.GET_PRESCRIPTION + id);
}
export function addExamination(id, reqData) {
  return apiProvider.post(urlConstants.ADD_EXAMINATION + id, reqData);
}
export function getExamination(id) {
  return apiProvider.getAll(urlConstants.GET_EXAMINATION + id);
}
export function getMedicineOrder(id) {
  return apiProvider.getAll(urlConstants.GET_MEDICINE_ORDER + id);
}

export function addDAMS(reqData) {
  return apiProvider.post(urlConstants.ADD_DAMS, reqData);
}

export function patientMedicinePurchase(id, reqData) {
  return apiProvider.post(urlConstants.PATIENT_PURCHASE_MEDICINE + id, reqData);
}
export function cancelBil(id, reqData) {
  return apiProvider.post(urlConstants.PATIENT_PURCHASE_MEDICINE_CANCEL + id, reqData);
}

export function deleteEntry(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_PAYMENT_ENTRY + id);
}

export function saleReturnList(query) {
  return apiProvider.getAll(urlConstants.SALE_RETURN_LIST + query);
}

export function addSaleReturn(reqData) {
  return apiProvider.post(urlConstants.ADD_SALE_RETURN, reqData);
}

export function getUsers(query, reqData) {
  return apiProvider.post(urlConstants.GET_USERS_LIST + query, reqData);
}

export function upsertUser(reqData) {
  return apiProvider.post(urlConstants.UPSERT_USERS, reqData);
}

export function changeUserStatus(query) {
  return apiProvider.post(urlConstants.CHANGE_USER_STATUS + query);
}

export function getDashboardData(query) {
  return apiProvider.getAll(urlConstants.GET_DASHBOARD_DATA + query);
}

export function getSaleData(query) {
  return apiProvider.getAll(urlConstants.GET_SALE_DATA + query);
}

export function getCollectionData(query) {
  return apiProvider.getAll(urlConstants.GET_COLLECTION_DATA + query);
}

export function getDashboardGraphs(query = "") {
  return apiProvider.post(urlConstants.GET_DASHBOARD_GRAPHS + query);
}

export const getReportTypes = (query) => {
  return apiProvider.getAll(urlConstants.GET_REPORT_TYPES + query);
};

export const getMedicineSaleHistory = (query) => {
  return apiProvider.post(urlConstants.MEDICINE_SALE_HISTORY + query);
};

export const getServiceSaleHistory = (query) => {
  return apiProvider.post(urlConstants.SERVICE_SALE_HISTORY + query);
};

export const submitExportDataRequest = (query) => {
  return apiProvider.post(urlConstants.EXPORT_DATA_REQ + query);
};

export const exportDataList = (query) => {
  return apiProvider.post(urlConstants.EXPORT_DATA_LIST + query);
};

export const deleteExportData = (id) => {
  return apiProvider.deleteAPI(urlConstants.DELETE_EXPORT_DATA + id);
};

export const getInvoicePDF = (query) => {
  return apiProvider.post(urlConstants.INVOICE_ORDER_PDF + query);
};

export const getPrescriptionPDF = (query) => {
  return apiProvider.getAll(urlConstants.PRESCRIPTION_PDF + query);
};

export const getPatientInvestigationDetails = (query) => {
  return apiProvider.post(urlConstants.PATIENT_INVESTIGATION_DETAILS + query);
};

export const upsertPatientInvestigationDetails = (reqData) => {
  return apiProvider.post(urlConstants.PATIENT_INVESTIGATION_DETAILS, reqData);
};

// Function removed

// Function removed

export const getAttendanceList = (query) => {
  return apiProvider.post(urlConstants.ATTENDANCE + query);
};

export const addAttendance = (reqData) => {
  return apiProvider.post(urlConstants.ATTENDANCE + "/upsert", reqData);
};
export function getExpenseCategoryList(query) {
  return apiProvider.getAll(urlConstants.GET_EXPENSE_CATEGORY_LIST + query);
}
export function addExpenseCategory(reqData) {
  return apiProvider.post(urlConstants.ADD_EXPENSE_CATEGORY, reqData);
}
export function editExpenseCategory(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_EXPENSE_CATEGORY + id, reqData);
}

export function changeExpenseCategoryStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_EXPENSE_CATEGORY_STATUS + id, reqData);
}
export function getExpenseList(query) {
  return apiProvider.getAll(urlConstants.GET_EXPENSE_LIST + query);
}
export function addExpense(reqData) {
  return apiProvider.post(urlConstants.ADD_EXPENSE, reqData);
}
export function editExpense(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_EXPENSE + id, reqData);
}
export function deleteExpense(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_EXPENSE + id);
}
export function getRoomList(query) {
  return apiProvider.getAll(urlConstants.GET_ROOM_LIST + query);
}
export function addRoom(reqData) {
  return apiProvider.post(urlConstants.ADD_ROOM, reqData);
}
export function editRoom(reqData) {
  return apiProvider.post(urlConstants.EDIT_ROOM, reqData);
}
export function changeRoomStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_ROOM_STATUS + id, reqData);
}
export function getBedList(query) {
  return apiProvider.getAll(urlConstants.GET_BED_LIST + query);
}
export function addBed(reqData) {
  return apiProvider.post(urlConstants.ADD_BED, reqData);
}
export function editBed(reqData) {
  return apiProvider.post(urlConstants.EDIT_BED, reqData);
}
export function changeBedStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_BED_STATUS + id, reqData);
}
export const getBedInfo = (id) => {
  return apiProvider.getAll(urlConstants.GET_BED_INFO + id);
};
export function addIPD(reqData) {
  return apiProvider.post(urlConstants.ADD_IPD, reqData);
}
export function getIpdList(query) {
  return apiProvider.post(urlConstants.GET_IPD_LIST, query);
}
export function showIpdStatus(id) {
  return apiProvider.getAll(urlConstants.SHOW_IPD_STATUS + id);
}
export function getIpdDetailsWithVisits(id) {
  return apiProvider.getAll(urlConstants.GET_IPD_DETAILS_WITH_VISITS + id);
}
export function addDoctorVisit(id, reqData) {
  return apiProvider.post(urlConstants.DOCTOR_VISIT + id, reqData);
}
export function patientDischarge(id, reqData) {
  return apiProvider.post(urlConstants.PATIENT_DISCHARGE + id, reqData);
}
export function addPatientNotes(id, reqData) {
  return apiProvider.post(urlConstants.ADD_NOTES + id, reqData);
}
export const getAllNotes = (id) => {
  return apiProvider.getAll(urlConstants.GET_NOTES + id);
};
export function paymentBill(reqData) {
  return apiProvider.post(urlConstants.ADD_PAYMENT, reqData);
}
export function getAlertList(query) {
  return apiProvider.post(urlConstants.GET_ALERT_LIST, query);
}
export function getAlertMedicineList(query) {
  return apiProvider.post(urlConstants.GET_ALERT_MEDICINE_LIST, query);
}
export function addAlert(reqData) {
  return apiProvider.post(urlConstants.ADD_ALERT, reqData);
}
export function deleteAlert(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_ALERT + id);
}
export function calanderStats(query) {
  return apiProvider.post(urlConstants.CALENDAR_STATS + query);
}
export function getBroadCastList(query) {
  return apiProvider.post(urlConstants.GET_BROADCASE_LIST, query);
}
export function addBroadcast(reqData) {
  return apiProvider.post(urlConstants.ADD_BROADCAST, reqData);
}
export function edidBroadcase(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_BROADCAST + id, reqData);
}
export function deleteSchedule(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_SCHEDULE + id);
}
export function addTemplate(reqData) {
  return apiProvider.post(urlConstants.ADD_TEMPLATE, reqData);
}
export function getTemplateList(query) {
  return apiProvider.post(urlConstants.GET_TEMPLATE_LIST, query);
}

export function getTemplateDetail(id) {
  return apiProvider.getAll(urlConstants.GET_TEMPLATE_DETAIL + id);
}

export function deleteTemplate(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_TEMPLATE + id);
}
export function getDownloadExcel() {
  return apiProvider.getAll(urlConstants.GET_DOWNLOAD_EXCEL);
}
export function getPatient(reqData) {
  return apiProvider.post(urlConstants.GET_PATIENTS, reqData);
}
export function getAutoSuggestion(reqData) {
  return apiProvider.post(urlConstants.AUTO_SUGGESTION, reqData);
}

// Notification Partner APIs
export function getNotificationPartnersList(query) {
  return apiProvider.getAll(urlConstants.GET_NOTIFICATION_PARTNERS_LIST + query);
}

export function updateNotificationPartnerCredentials(id, credentials) {
  return apiProvider.post(
    `${urlConstants.UPDATE_NOTIFICATION_PARTNER_CREDENTIALS}/${id}/credentials`,
    credentials,
  );
}

export function getNotificationsList(query) {
  return apiProvider.getAll(urlConstants.GET_NOTIFICATIONS_LIST + query);
}

export function getNotificationLogsList(query) {
  return apiProvider.post(urlConstants.GET_NOTIFICATION_LOGS_LIST, query);
}

export function updateNotification(id, reqData) {
  return apiProvider.post(urlConstants.UPDATE_NOTIFICATIONS + id, reqData);
}

export function addDiagnosis(reqData) {
  return apiProvider.post(urlConstants.ADD_DIAGNOSIS, reqData);
}
export function editDiagnosis(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_DIAGNOSIS + id, reqData);
}
export function getDiagnosisList(query) {
  return apiProvider.getAll(urlConstants.GET_DIAGNOSIS + query);
}
export function changeDiagnosisStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_DIAGNOSIS_STATUS + id, reqData);
}
export function updatePatientDiagnosis(reqData) {
  return apiProvider.post(urlConstants.UPDATE_PATIENT_DIAGNOSIS, reqData);
}
export function updatePatientTreatment(reqData) {
  return apiProvider.post(urlConstants.UPDATE_PATIENT_TREATMENT, reqData);
}
export const getPatientTreatmentDetails = (query) => {
  return apiProvider.post(urlConstants.PATIENT_TREATMENT_DETAILS + query);
};
export const getPatientDiagnosisDetails = (query) => {
  return apiProvider.post(urlConstants.PATIENT_DIAGNOSIS_DETAILS + query);
};

export function getPatientDetailsWithId(id) {
  return apiProvider.getAll(urlConstants.GET_PATIENT_DETAILS_WITH_ID + id);
}
export function uploadDocument(url, reqData) {
  return apiProvider.post(url, reqData);
}
export const getUploadedPatientDocument = (url, query) => {
  return apiProvider.post(url, query);
};

export function getApplicationList(query) {
  return apiProvider.getAll(urlConstants.GET_APPLICATION_LIST + query);
}

export function addApplication(reqData) {
  return apiProvider.post(urlConstants.ADD_APPLICATION, reqData);
}

export function editApplication(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_APPLICATION + id, reqData);
}

export function changeApplicationStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_APPLICATION_STATUS + id, reqData);
}
export function updatePatient(id, reqData) {
  return apiProvider.post(urlConstants.UPDATE_PATIENT + id, reqData);
}
export function getTreatmentList(query) {
  return apiProvider.getAll(urlConstants.GET_TREATMENT_LIST + query);
}

export function addTreatment(reqData) {
  return apiProvider.post(urlConstants.ADD_TREATMENT, reqData);
}

export function editTreatment(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_TREATMENT + id, reqData);
}

export function changeTreatmentStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_TREATMENT_STATUS + id, reqData);
}

export const uploadTemplateMedia = (formData) => {
  return apiProvider.post(urlConstants.UPLOAD_TEMPLATE_MEDIA, formData);
};

export function addPatient(reqData) {
  return apiProvider.post(urlConstants.ADD_PATIENT, reqData);
}

export function getMedicineCategoryList(query) {
  return apiProvider.getAll(urlConstants.GET_MEDICINE_CATEGORY_LIST + query);
}

export function addMedicineCategory(reqData) {
  return apiProvider.post(urlConstants.ADD_MEDICINE_CATEGORY, reqData);
}

export function editMedicineCategory(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_MEDICINE_CATEGORY + id, reqData);
}

export function changeMedicineCategoryStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_MEDICINE_CATEGORY_STATUS + id, reqData);
}

export function getInventoryCategoryList(query) {
  return apiProvider.getAll(urlConstants.GET_INVENTORY_CATEGORY_LIST + query);
}

export function addInventoryCategory(reqData) {
  return apiProvider.post(urlConstants.ADD_INVENTORY_CATEGORY, reqData);
}

export function editInventoryCategory(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_INVENTORY_CATEGORY + id, reqData);
}

export function changeInventoryCategoryStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_INVENTORY_CATEGORY_STATUS + id, reqData);
}

export function getInventoryList(query) {
  return apiProvider.getAll(urlConstants.GET_INVENTORY_LIST + query);
}

export function addInventory(reqData) {
  return apiProvider.post(urlConstants.ADD_INVENTORY, reqData);
}

export function addInventoryStock(reqData) {
  return apiProvider.post(urlConstants.ADD_INVENTORY_STOCK, reqData);
}

export function addInventoryConsume(reqData) {
  return apiProvider.post(urlConstants.ADD_INVENTORY_CONSUME, reqData);
}

export function addInventoryComment(reqData) {
  return apiProvider.post(urlConstants.ADD_INVENTORY_COMMENT, reqData);
}

export function getInventoryHistory(query) {
  return apiProvider.getAll(urlConstants.GET_INVENTORY_HISTORY + query);
}

export function editInventory(reqData) {
  return apiProvider.post(urlConstants.EDIT_INVENTORY, reqData);
}

export function changeInventoryStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_INVENTORY_STATUS + id, reqData);
}

export function getCustomBillingItemList(query) {
  return apiProvider.getAll(urlConstants.GET_CUSTOM_BILLING_ITEM_LIST + query);
}

export function addCustomBillingItem(reqData) {
  return apiProvider.post(urlConstants.ADD_CUSTOM_BILLING_ITEM, reqData);
}

export function editCustomBillingItem(id, reqData) {
  return apiProvider.post(urlConstants.EDIT_CUSTOM_BILLING_ITEM + id, reqData);
}

export function changeCustomBillingItemStatus(id, reqData) {
  return apiProvider.post(urlConstants.CHANGE_CUSTOM_BILLING_ITEM_STATUS + id, reqData);
}

export function deleteTreatment(id) {
  return apiProvider.deleteAPI(urlConstants.DELETE_TREATMENT + id);
}
